import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import Framework from '../components/framework';
import Breadcrumb from '../components/framework/breadcrumb';
import Trans from '../components/translation/trans';
import useTranslation from '../hooks/use_translation';
import { getVariantByLanguage } from '../utils/helpers';

const SupportItem = ({ data, location }) => {
	const article = data.article;
	const { language, t } = useTranslation('template_support_item');
	const variant = getVariantByLanguage(language, article.article_variants);

	return (
		<Framework
			description={variant.seo_description}
			location={location}
			tags={variant.seo_keywords}
			title={variant.seo_title}
			tracking={{ content_group: 'Support' }}
		>
			<div className="container mt-lg-3 mt-2 px-0" id="content">
				<nav aria-label="breadcrumb">
					<Breadcrumb
						className=""
						links={[
							{
								base_url: '/support',
								id:
									article.groups && article.groups.length
										? article.groups[0]
										: null,
								type: 'group',
							},
							{ active: true, title: variant.title },
						]}
						support={true}
					/>
				</nav>
			</div>
			<div className="container">
				<div className="row ">
					<div className="col-md-8 article-content">
						<h1 className="title-medium">{variant.title}</h1>
						<Trans defaults={variant.content} t={t} />
					</div>
				</div>
			</div>
		</Framework>
	);
};

SupportItem.propTypes = {
	data: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
};

export default SupportItem;

export const pageQuery = graphql`
	query SupportItemById($id: String!) {
		article(id: { eq: $id }) {
			groups
			type
			article_variants {
				content
				excerpt
				language {
					code
				}
				seo_description
				seo_keywords
				seo_title
				slug
				title
			}
		}

		locales: allLocale {
			...translationFields
		}
	}
`;
